import gql from "graphql-tag"

export const driverFieldsFragment = gql`
  fragment driverFields on Driver {
    uuid
    id
    name
    description
    Etag
    contentId
  }
`
